/**
 * export all store api's
 */

import { cupApi } from './cups/api';
import { globalApi } from './global/api';
import { historyApi } from './history/api';
import { modalityApi } from './modality/api';
import { competitionTypesApi } from './competition-types/api';

export const API = {
  globalApi,
  modalityApi,
  historyApi,
  cupApi,
  competitionTypesApi,
};

export type APIKeys = keyof typeof API;
export type APIType = (typeof API)[APIKeys];
